import { useContext } from "react";
import { editorDataContext } from "../EditorContext.js";
function useEditorData() {
  const ctx = useContext(editorDataContext);
  if (!ctx) throw new Error("Must be used as a descendant of Editor");
  return ctx;
}
export {
  useEditorData
};
//# sourceMappingURL=useEditorData.js.map
